export enum RequestOriginAppSR {
    Armature = 'Armiračnica',
    Warehouse = 'Stovarište',
    Transport = 'Transport',
}
